'use client'

import { Cell, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const FormHeader = () => {
  const translate = useTranslate('advertising.form')

  return (
    <Cell styling="wide">
      <Text text={translate('title')} type="heading" as="h2" />
      <Spacer size="large" />
      <Text as="span" text={translate('subtitle')} theme="muted" />
    </Cell>
  )
}

export default FormHeader
